import * as React from "react";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import { OutlinedInput } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { appLogger } from "../../../utils";

import AgentButtons from "./WebAgentPreview/AgentButtons";
import SelectCategory from "./WebAgentPreview/SelectCategory";
import AttachmentBox from "./WebAgentPreview/AttachmentBox";
import FooterLogo from "./WebAgentPreview/FooterLogo";

import "./PreviewStyles/index.css";

const startRatings = [1, 2, 3, 4, 5];

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  // padding: theme.spacing(1),
  color: theme.palette.text.secondary,
  boxShadow: "none",
  background: "none",
}));

const FeedbackSettingsPreview = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "FeedbackSettingsPreview",
      component: "add-product",
      fileName: "FeedbackSettingsPreview.tsx",
      props: props,
    },
  });
  const { productParams } = props;
  const [checked, setChecked] = React.useState([0]);
  const [StdFbscontent, setStdFbscontent] = React.useState<any>("");
  const [selectedCat, setselectedCat] = React.useState<any>("");
  const [PreviewZoom, setPreviewZoom] = React.useState<any>("zoomout");
  const [previewAgent, setPreviewAgent] = React.useState<boolean>(false);

  const handleConvertPxToPt = (value: string) => {
    const cleanValue = value.replace("px", "");
    const newValue = previewAgent
      ? `${cleanValue}px`
      : parseInt(cleanValue) / 1.2 + "px";

    return newValue;
  };

  const handleTogglePreview = () => {
    setPreviewAgent((prevState) => !prevState);
  };

  const handleToggle = (value: number) => () => {
    const currentIndex = checked.indexOf(value);

    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const FdSettingsRatingStar = () => {
    return (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.feedbackSettings?.ratingLimit || 0
    );
  };

  const FbTopRatingMsg = () => {
    return (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.feedbackSettings?.ratingHeading || ""
    );
  };

  const FdSettingsrequireEmail = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.requireEmail == true
      ? "(required)"
      : "(optional)";
  };
  const GenSettingsFbcategoryHeading = () => {
    return (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.feedbackSettings?.categoryHeading || ""
    );
  };
  const FdSettingsrequireCategory = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.feedbackSettings?.reqCategory == true
      ? "(required)"
      : "(optional)";
  };

  const GenSettingsFbCommentsHeading = () => {
    return (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.feedbackSettings?.generalCommentsHeading || ""
    );
  };

  const GenSettingsFbCommentreqComments = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.feedbackSettings?.reqComments == true
      ? " (required)"
      : " (optional)";
  };

  const FbTopdialogMsg = () => {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html:
            productParams.productParams.products[0].feedbackAgentSettings
              ?.feedbackSettings?.dialogMsg || "",
        }}
      ></div>
    );
  };

  const FbTooltipMsg = () => {
    return (
      productParams.productParams.products[0].feedbackAgentSettings?.subtitle ||
      ""
    );
  };
  const renderGeneralSettingsMainTitle = () => {
    return (
      productParams.productParams.products[0].feedbackAgentSettings?.title || ""
    );
  };
  const Mainlogo = () => {
    return productParams.productParams.products[0]?.logo;
  };

  const handleCatChange = (event: any) => {
    setselectedCat(event.target.value);
    // productParams.productParams.products[0].feedbackAgentSettings?.feedbackSettings?.categories.map(
    //   (val: any, index: any) => {
    //     if (val.name == event.target.value) {
    //       CatFbStdFeedbacks(event.target.value);
    //     }
    //   }
    // );
  };
  React.useEffect(() => {
    if (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.feedbackSettings?.categories?.length == 1
    ) {
      // setselectedCat(
      //   productParams.productParams.products[0].feedbackAgentSettings
      //     ?.feedbackSettings?.categories[0].name
      // );
      // CatFbStdFeedbacks(
      //   productParams.productParams.products[0].feedbackAgentSettings
      //     ?.feedbackSettings?.categories[0].name
      // );
    } else {
      setselectedCat("");
      setStdFbscontent("");
    }
  }, [productParams]);

  //   const fullSize = () => {
  //     const docElm: any = document.getElementById('myvideo')

  //     if (docElm.requestFullscreen()) {
  //       // exitFullscreen is only available on the Document object.
  //       docElm.exitFullscreen()
  //       setPreviewZoom('zoomout')
  //     } else {
  //       docElm.requestFullscreen()
  //       setPreviewZoom('zoomin')
  //     }

  //     return
  //   }
  // const fullscreenchanged = (event: any) => {
  //   // document.fullscreenElement will point to the element that
  //   // is in fullscreen mode if there is one. If not, the value
  //   // of the property is null.
  //   if (document.fullscreenElement) {
  //     setPreviewZoom("zoomin");
  //   } else {
  //     setPreviewZoom("zoomout");
  //   }
  // };

  // const el: any = document.getElementById("fullscreen-div");
  // const tt: any = document.getElementById("toggle-fullscreen");

  // if (el != null) {
  //   el.addEventListener("fullscreenchange", fullscreenchanged);
  //   // or
  //   el.onfullscreenchange = fullscreenchanged;
  // }

  // if (tt != null) {
  //   // When the toggle button is clicked, enter/exit fullscreen

  //   tt.addEventListener("click", (event: any) => {
  //     if (document.fullscreenElement) {
  //       // exitFullscreen is only available on the Document object.
  //       document.exitFullscreen();
  //     } else {
  //       el.requestFullscreen();
  //     }
  //   });
  // }
  // const zoomClick = () => (event: any) => {
  //   const fullscreendiv: any = document.getElementById("fullscreen-div");
  //   if (document.fullscreenElement) {
  //     setPreviewZoom("zoomout");
  //     // exitFullscreen is only available on the Document object.
  //     document.exitFullscreen();
  //   } else {
  //     fullscreendiv.requestFullscreen();
  //     setPreviewZoom("zoomin");
  //   }
  // };

  const brandingCuvoPopupDialogAgentbg = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-agent-bg"];
  };

  const renderMainTitleColor = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-main-title"];
  };
  const renderMainTitleFontSize = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-main-title-font-size"];
  };
  const renderMainTitleFontWeight = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-main-title-font-weight"];
  };
  const renderMainTitleFontStyle = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-main-title-font-style"];
  };
  const renderMainTitleFontFamily = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-main-title-font-family"];
  };
  const renderSubTitleFontSize = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-main-subtitle-font-size"];
  };
  const renderSubTitleFontWeight = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-main-subtitle-font-weight"];
  };
  const renderSubTitleFontStyle = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-main-subtitle-font-style"];
  };
  const renderSubTitleFontFamily = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-main-subtitle-font-family"];
  };
  const renderSubTitleColor = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-popup-dialog-main-subtitle"];
  };
  const renderprimayBtnColor = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-primary-button-bg"];
  };
  const renderprimayBtnBorderRadius = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-primary_btn-border-radius"];
  };
  const renderprimayBtnBorderColor = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-primary-button-border-color"];
  };

  const rendersecondaryBtnBorderRadius = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-secondary_btn-border-radius"];
  };

  const rendersecondaryBtnBorderColor = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-secondary-button-border-color"];
  };

  const renderprimayBtnTextColor = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-primary-button-text-color"];
  };
  const renderprimayBtnFontFamily = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-primary-button-text-font-family"];
  };
  const renderprimayBtnFontSize = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-primary-button-text-font-size"];
  };

  const renderprimayBtnFontWeight = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-primary-button-text-font-weight"];
  };
  const renderprimayBtnFontStyle = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-primary-button-text-font-style"];
  };

  const rendersecondaryBtnColor = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-secondary-button-bg"];
  };
  const rendersecondaryBtnTextColor = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-secondary-button-text-color"];
  };
  const rendersecondaryBtnFontFamily = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-secondary-button-text-font-family"];
  };
  const rendersecondaryBtnFontSize = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-secondary-button-text-font-size"];
  };

  const rendersecondaryBtnFontWeight = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-secondary-button-text-font-weight"];
  };
  const rendersecondaryBtnFontStyle = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-secondary-button-text-font-style"];
  };

  const renderInputLabelColor = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-input-label-color"];
  };
  const renderInputLabelFontSize = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-input-label-font-size"];
  };
  const renderInputLabelFontWeight = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-input-label-font-weight"];
  };
  const renderInputLabelFontStyle = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-input-label-font-style"];
  };
  const renderInputLabelFontFamily = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-input-label-font-family"];
  };

  const renderInputFieldTextColor = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-input-field-text-color"];
  };

  const renderInputFieldBGColor = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-input-field-bg-color"];
  };

  const renderAttachmentHelperColor = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-attachment-helper-color"];
  };
  const renderAttachmentHelperFontSize = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-attachment-helper-font-size"];
  };
  const renderAttachmentHelperFontWeight = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-attachment-helper-font-weight"];
  };
  const renderAttachmentHelperFontStyle = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-attachment-helper-font-style"];
  };
  const renderAttachmentHelperFontFamily = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-attachment-helper-font-family"];
  };

  const renderAttachmentHelperText = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      .feedbackSettings.attachmentHelp;
  };
  const renderSelectedStarClr = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-selected-star-color"];
  };
  const renderUnSelectedStarClr = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-unselected-star-color"];
  };
  const renderInputFieldBorderColor = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-input-border-color"];
  };
  const renderInputFieldBorderRadius = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-input-border-radius"];
  };
  const renderCommentfieldHeight = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-comments-field-height"];
  };
  const renderEditorFontSize = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-editor-font-size"];
  };
  const renderEditorFontFamily = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-editor-font-family"];
  };
  const renderCardBorderClr = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-card-border-color"];
  };
  const renderCardBorderRadius = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.branding["branding-cuvo-card-border-radius"];
  };

  const CatFbStdFeedbacks = (checkName: any) => {
    const selectedCategory =
      productParams.productParams.products[0].feedbackAgentSettings?.feedbackSettings?.categories.find(
        (category: any) => category.name === checkName
      );
    if (selectedCategory?.feedbacks?.length) {
      return selectedCategory?.feedbacks.map((value: any) => {
        return (
          <Box
            display="flex"
            alignItems="center"
            sx={{
              marginTop: "10px",
            }}
          >
            <input
              type="checkbox"
              name={value}
              value={value}
              style={{
                width: "20px",
                height: "17px",
                marginRight: "5px",
                background: renderInputFieldBGColor(),
                border: `1px solid ${renderInputFieldBorderColor()}`,
                borderRadius: renderInputFieldBorderRadius(),
              }}
            />
            <label
              style={{
                // fontSize: `${handleConvertPxToPt(
                //   productParams?.productParams?.products[0]
                //     .feedbackAgentSettings?.branding?.[
                //     brandingConstants.inputLabelFontSize
                //   ]
                // )}!important`,
                // fontFamily: `${
                //   productParams?.productParams?.products[0]
                //     .feedbackAgentSettings?.branding?.[
                //     brandingConstants.inputLabelFontFamily
                //   ]
                // }!important`,
                // fontWeight: `${
                //   productParams?.productParams?.products[0]
                //     .feedbackAgentSettings?.branding?.[
                //     brandingConstants.inputLabelFontWeight
                //   ]
                // }!important`,
                // color: `${
                //   productParams?.productParams?.products[0]
                //     .feedbackAgentSettings?.branding?.[
                //     brandingConstants.inputLabelColor
                //   ]
                // }!important`,

                color: renderInputLabelColor(),
                fontSize: renderInputLabelFontSize(),
                fontStyle: renderInputLabelFontStyle(),
                fontFamily: renderInputLabelFontFamily(),
                fontWeight: renderInputLabelFontWeight(),
              }}
            >
              {value}
            </label>
          </Box>
        );
      });
    }
  };

  const FdSettingsCategories = () => {
    let content: any = "";
    if (
      productParams.productParams.products[0].feedbackAgentSettings
        ?.feedbackSettings?.categories?.length > 0
    ) {
      content = (
        // <>
        //   <Typography sx={{ mt: 1 }}>
        //     <InputLabel
        //       id="demo-simple-select-label"
        //       sx={{
        //         margin: "15px 0 8px",
        //         color: renderInputLabelColor(),
        //         fontSize: renderInputLabelFontSize(),
        //         fontStyle: renderInputLabelFontStyle(),
        //         fontFamily: renderInputLabelFontFamily(),
        //         fontWeight: renderInputLabelFontWeight(),
        //       }}
        //     >
        //       {` ${GenSettingsFbcategoryHeading()} ${FdSettingsrequireCategory()}`}
        //     </InputLabel>
        //     <FormControl fullWidth>
        //       <Select
        //         className="noborder feedback-input"
        //         value={selectedCat}
        //         inputProps={{ "aria-label": "Without label" }}
        //         onChange={(event) => handleCatChange(event)}
        //         displayEmpty
        //         sx={{
        //           color: renderInputFieldTextColor(),
        //           backgroundColor: renderInputFieldBGColor(),
        //           border: "1px solid " + renderInputFieldBorderColor(),
        //           borderRadius: renderInputFieldBorderRadius(),
        //           "& input": {
        //             fontSize: previewAgent
        //               ? "14px!important"
        //               : "11px!important",
        //             fontFamily: `${renderInputLabelFontFamily()}!important`,
        //           },
        //           "& .MuiSelect-select": {
        //             padding: "0px!important",
        //           },
        //         }}
        //       >
        //         <MenuItem value="" disabled>{`Select a Category ${
        //           productParams.productParams.products[0].feedbackAgentSettings
        //             ?.feedbackSettings?.reqCategory == true
        //             ? "*"
        //             : ""
        //         }`}</MenuItem>
        //         {productParams.productParams.products[0].feedbackAgentSettings?.feedbackSettings?.categories.map(
        //           (val: any, index: any) => (
        //             <MenuItem value={val.name}>{val.name}</MenuItem>
        //           )
        //         )}
        //       </Select>
        //     </FormControl>
        //   </Typography>
        // </>
        <SelectCategory
          value={selectedCat}
          renderInputLabelColor={renderInputLabelColor}
          renderInputLabelFontSize={renderInputLabelFontSize}
          renderInputLabelFontStyle={renderInputLabelFontStyle}
          renderInputLabelFontFamily={renderInputLabelFontFamily}
          renderInputLabelFontWeight={renderInputLabelFontWeight}
          heading={GenSettingsFbcategoryHeading}
          requireCategory={FdSettingsrequireCategory}
          renderInputFieldTextColor={renderInputFieldTextColor}
          renderInputFieldBGColor={renderInputFieldBGColor}
          renderInputFieldBorderColor={renderInputFieldBorderColor}
          renderInputFieldBorderRadius={renderInputFieldBorderRadius}
          previewAgent={previewAgent}
          handleCatChange={handleCatChange}
          productParams={productParams}
          feedbackType="feedbackSettings"
        />
      );
    }
    return content;
  };

  return (
    <>
      <Typography className="prev-text-titile">
        Single-page feedback settings : Agent Preview &nbsp;
      </Typography>
      {!previewAgent && (
        <div className="">
          <Typography
            className="web-agent-preview-btn guideTourViewActualSize"
            onClick={handleTogglePreview}
            sx={{ color: "#0157FF", fontSize: 12 }}
          >
            Click to preview actual size
          </Typography>
        </div>
      )}
      {previewAgent && <Box className="general-settings-overlay" />}
      <div
        id="genset-fullscreen-div"
        className={`genset-fullscreen-div general-settings-container ${
          previewAgent ? "general-settings-preview" : ""
        } `}
        style={{
          height: previewAgent ? "100%" : "auto",
          marginTop: previewAgent ? "0px" : "8px",
          padding: previewAgent ? "20px 20px 20px 50px" : "16px",
          boxShadow:
            "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
          background: brandingCuvoPopupDialogAgentbg(),
        }}
      >
        {previewAgent && (
          <Typography className="gen-prev-icon">
            For Preview{" "}
            <span onClick={handleTogglePreview} className="prevclose">
              {" "}
              &nbsp; x &nbsp;Close &nbsp;
            </span>
          </Typography>
        )}
        <Grid
          className={PreviewZoom}
          container
          flexDirection="column"
          flexWrap="nowrap"
          sx={{
            // mt: 1,
            // p: 2,
            // border: "1px solid #dbdce0",
            // height: previewAgent ? "100%" : "auto",
            // marginTop: previewAgent ? "0px" : "8px",
            // padding: previewAgent ? "20px 20px 20px 50px" : "16px",
            // boxShadow:
            //   "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
            // background: brandingCuvoPopupDialogAgentbg(),
            // overflow: previewAgent ? "auto" : "inherit",
            // position: "relative",
            height: "100%",
          }}
        >
          <button
            className={`${
              previewAgent
                ? "cuvo-popup-dialog-close"
                : "cuvo-popup-dialog-close-small"
            }`}
            style={{
              backgroundColor: renderprimayBtnColor(),
              fontSize: !previewAgent ? "13px" : "20px",
              color: renderprimayBtnTextColor(),
              border: "none",
            }}
          >
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="122.878px"
              height="122.88px"
              viewBox="0 0 122.878 122.88"
              enable-background="new 0 0 122.878 122.88"
              style={{ fill: renderprimayBtnTextColor() }}
            >
              <g>
                <path d="M1.426,8.313c-1.901-1.901-1.901-4.984,0-6.886c1.901-1.902,4.984-1.902,6.886,0l53.127,53.127l53.127-53.127 c1.901-1.902,4.984-1.902,6.887,0c1.901,1.901,1.901,4.985,0,6.886L68.324,61.439l53.128,53.128c1.901,1.901,1.901,4.984,0,6.886 c-1.902,1.902-4.985,1.902-6.887,0L61.438,68.326L8.312,121.453c-1.901,1.902-4.984,1.902-6.886,0 c-1.901-1.901-1.901-4.984,0-6.886l53.127-53.128L1.426,8.313L1.426,8.313z"></path>
              </g>
            </svg>
          </button>

          <Grid
            container
            item
            xs={12}
            justifyContent="space-between"
            alignItems="baseline"
            flexBasis="unset!important"
          >
            <Box className="gen-maintitle">
              <Typography
                sx={{
                  color: renderMainTitleColor(),
                  fontSize: !previewAgent
                    ? parseInt(renderMainTitleFontSize()) / 1.9 + "px"
                    : renderMainTitleFontSize(),
                  fontStyle: renderMainTitleFontStyle(),
                  fontFamily: renderMainTitleFontFamily(),
                  fontWeight: renderMainTitleFontWeight(),
                }}
              >
                {renderGeneralSettingsMainTitle()}
              </Typography>
              <Typography
                style={{
                  color: renderSubTitleColor(),
                  fontSize: !previewAgent
                    ? parseInt(renderSubTitleFontSize()) / 1.9 + "px"
                    : renderSubTitleFontSize(),
                  fontStyle: renderSubTitleFontStyle(),
                  fontFamily: renderSubTitleFontFamily(),
                  fontWeight: renderSubTitleFontWeight(),
                }}
              >
                {FbTooltipMsg()}
              </Typography>
            </Box>
            {productParams.productParams.products[0].feedbackAgentSettings
              .showLogo && (
              <img
                style={{ width: previewAgent ? "100px" : "60px" }}
                src={Mainlogo()}
              />
            )}
          </Grid>

          <Grid
            container
            sx={{
              minHeight: "calc(100vh - 300px)",
              padding: "0 15px 0 0",
              overflow: "auto",
            }}
          >
            <Grid item xs={12} md={12}>
              <Grid item xs={12}>
                <Typography
                  className="fbtopdialogtitle"
                  sx={{
                    fontSize: !previewAgent
                      ? parseInt(renderEditorFontSize()) / 1.2 + "px"
                      : renderEditorFontSize(),
                    fontFamily: renderEditorFontFamily(),
                  }}
                >
                  {FbTopdialogMsg()}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography
                  sx={{
                    color: renderInputFieldTextColor(),
                    fontSize: renderInputLabelFontSize(),
                    fontStyle: renderInputLabelFontStyle(),
                    fontFamily: renderInputLabelFontFamily(),
                    fontWeight: renderInputLabelFontWeight(),
                    textAlign: "center",
                    mt: 2,
                  }}
                >
                  {FbTopRatingMsg()}
                </Typography>
              </Grid>
              <Typography
                className="fbrating feedback-rating"
                sx={{
                  textAlign: "center",
                  fontSize: "2.5rem",
                  marginTop: "5px",
                }}
              >
                {startRatings.map((rating) => {
                  const startColor =
                    rating > 3
                      ? renderUnSelectedStarClr()
                      : renderSelectedStarClr();
                  return (
                    <span style={{ padding: "8px", cursor: "pointer" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 122.88 117.1"
                        aria-labelledby="star"
                        id="star"
                      >
                        <path
                          style={{
                            fill: startColor,
                          }}
                          className="star"
                          d="M64.42,2,80.13,38.7,120,42.26a3.2,3.2,0,0,1,1.82,5.62h0L91.64,74.18l8.9,39A3.19,3.19,0,0,1,98.12,117a3.27,3.27,0,0,1-2.46-.46L61.41,96.1,27.07,116.64a3.18,3.18,0,0,1-4.38-1.09,3.14,3.14,0,0,1-.37-2.38h0l8.91-39L1.09,47.88a3.24,3.24,0,0,1-.32-4.52,3.32,3.32,0,0,1,2.29-1l39.72-3.56L58.49,2a3.24,3.24,0,0,1,5.93,0Z"
                        ></path>
                      </svg>
                    </span>
                  );
                })}
              </Typography>
              <Box className="form-wrap">
                <Box
                  component="form"
                  method="post"
                  noValidate
                  className="custom-select custom-select-agent-box"
                >
                  <Box className="custom-select-agent" mb="10px">
                    <Typography
                      sx={{
                        margin: "15px 0 8px",
                        color: renderInputLabelColor(),
                        fontSize: renderInputLabelFontSize(),
                        fontStyle: renderInputLabelFontStyle(),
                        fontFamily: renderInputLabelFontFamily(),
                        fontWeight: renderInputLabelFontWeight(),
                      }}
                    >
                      {`Email Address ${FdSettingsrequireEmail()}`}
                    </Typography>
                    <FormControl className="" fullWidth>
                      <OutlinedInput
                        className="noborder feedback-input"
                        sx={{
                          color: renderInputFieldTextColor(),
                          backgroundColor: renderInputFieldBGColor(),
                          border: "1px solid " + renderInputFieldBorderColor(),
                          borderRadius: renderInputFieldBorderRadius(),
                          "& input": {
                            fontSize: previewAgent
                              ? "14px!important"
                              : "11px!important",
                            fontFamily: `${renderInputLabelFontFamily()}!important`,
                            padding: "0px!important",
                          },
                        }}
                        id="desc-input"
                        placeholder="Your email"
                        type="text"
                        maxRows={4}
                      />
                    </FormControl>
                  </Box>

                  <> {FdSettingsCategories()}</>
                  <>{CatFbStdFeedbacks(selectedCat)} </>

                  <Typography>
                    <InputLabel
                      id="demo-simple-select-label"
                      sx={{
                        margin: "15px 0 8px",
                        color: renderInputLabelColor(),
                        fontSize: renderInputLabelFontSize(),
                        fontStyle: renderInputLabelFontStyle(),
                        fontFamily: renderInputLabelFontFamily(),
                        fontWeight: renderInputLabelFontWeight(),
                      }}
                    >
                      {GenSettingsFbCommentsHeading()}
                      {GenSettingsFbCommentreqComments()}
                    </InputLabel>
                    <FormControl
                      className="custom-select custom-textarea"
                      fullWidth
                    >
                      <OutlinedInput
                        className="noborder"
                        type="textarea"
                        id="desc-input"
                        multiline
                        placeholder={`Provide your comments ${
                          productParams.productParams.products[0]
                            .feedbackAgentSettings?.feedbackSettings
                            ?.reqComments == true
                            ? "*"
                            : ""
                        }`}
                        sx={{
                          color: renderInputFieldTextColor(),
                          backgroundColor: renderInputFieldBGColor(),
                          border: "1px solid" + renderInputFieldBorderColor(),
                          borderRadius: renderInputFieldBorderRadius(),
                          alignItems: "start",
                          padding: "10px 15px",
                          "& textarea": {
                            padding: "0px!important",
                            fontFamily: `${renderInputLabelFontFamily()}!important`,
                          },
                          height: "100px",
                        }}
                        maxRows={4}
                      />
                    </FormControl>
                  </Typography>
                  {/* ****************************** */}
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{
                      margin: "15px 0 8px",
                      whiteSpace: "normal",
                      color: renderInputLabelColor(),
                      fontSize: renderInputLabelFontSize(),
                      fontStyle: renderInputLabelFontStyle(),
                      fontFamily: renderInputLabelFontFamily(),
                      fontWeight: renderInputLabelFontWeight(),
                    }}
                  >
                    Please attach screenshot/audio/screen recording to help
                    troubleshoot (optional)
                  </InputLabel>
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{
                      mt: 1,
                      mb: "10px",
                      color: renderAttachmentHelperColor(),
                      fontSize: renderAttachmentHelperFontSize(),
                      fontStyle: renderAttachmentHelperFontStyle(),
                      fontFamily: renderAttachmentHelperFontFamily(),
                      fontWeight: renderAttachmentHelperFontWeight(),
                      whiteSpace: "normal",
                    }}
                  >
                    Note: {renderAttachmentHelperText()}
                  </InputLabel>
                  <AttachmentBox
                    previewAgent={previewAgent}
                    renderInputFieldBorderColor={renderInputFieldBorderColor}
                    renderInputFieldBorderRadius={renderInputFieldBorderRadius}
                    renderInputFieldBGColor={renderInputFieldBGColor}
                    renderInputFieldTextColor={renderInputFieldTextColor}
                  />
                  {/* *************************************** */}
                  <AgentButtons
                    previewAgent={previewAgent}
                    rendersecondaryBtnTextColor={rendersecondaryBtnTextColor}
                    rendersecondaryBtnColor={rendersecondaryBtnColor}
                    rendersecondaryBtnFontFamily={rendersecondaryBtnColor}
                    rendersecondaryBtnFontSize={rendersecondaryBtnFontSize}
                    rendersecondaryBtnFontWeight={rendersecondaryBtnFontWeight}
                    rendersecondaryBtnFontStyle={rendersecondaryBtnFontStyle}
                    rendersecondaryBtnBorderRadius={
                      rendersecondaryBtnBorderRadius
                    }
                    rendersecondaryBtnBorderColor={
                      rendersecondaryBtnBorderColor
                    }
                    renderprimayBtnTextColor={renderprimayBtnTextColor}
                    renderprimayBtnColor={renderprimayBtnColor}
                    renderprimayBtnFontFamily={renderprimayBtnFontFamily}
                    renderprimayBtnFontSize={renderprimayBtnFontSize}
                    renderprimayBtnFontWeight={renderprimayBtnFontWeight}
                    renderprimayBtnFontStyle={renderprimayBtnFontStyle}
                    renderprimayBtnBorderRadius={renderprimayBtnBorderRadius}
                    renderprimayBtnBorderColor={renderprimayBtnBorderColor}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>

          <FooterLogo
            previewAgent={previewAgent}
            renderInputLabelColor={renderInputLabelColor}
          />
        </Grid>{" "}
      </div>
    </>
  );
};

export default FeedbackSettingsPreview;
